import { SectionTypeEnum } from '@vedalib/editor/lib/elements'

import { BlockMode } from 'services/Store/Project/enums'
import type { Section } from 'services/Store/Project/types'

import type { IShortBlockData } from './EditorHotkeys'

type BlockCounter = { [key in BlockMode]: number }

const BLOCK_LIMITS: { [key in SectionTypeEnum]: BlockCounter } = {
  [SectionTypeEnum.landing]: {
    [BlockMode.start]: 0,
    [BlockMode.questions]: Infinity,
    [BlockMode.end]: 0,
    [BlockMode.cover]: 0,
    [BlockMode.view]: Infinity,
  },
  [SectionTypeEnum.test]: {
    [BlockMode.start]: 1,
    [BlockMode.questions]: Infinity,
    [BlockMode.end]: 1,
    [BlockMode.cover]: 0,
    [BlockMode.view]: 0,
  },
  [SectionTypeEnum.cover]: {
    [BlockMode.start]: 0,
    [BlockMode.questions]: 0,
    [BlockMode.end]: 0,
    [BlockMode.cover]: 1,
    [BlockMode.view]: 0,
  },
  [SectionTypeEnum.chapter]: {
    [BlockMode.start]: 0,
    [BlockMode.questions]: 0,
    [BlockMode.end]: 0,
    [BlockMode.cover]: 0,
    [BlockMode.view]: 0,
  },
}

const countBlocksByMode = (blocks: IShortBlockData[]) => {
  return blocks.reduce(
    (acc, { mode }) => {
      acc[mode] += 1
      return acc
    },
    {
      [BlockMode.start]: 0,
      [BlockMode.questions]: 0,
      [BlockMode.end]: 0,
      [BlockMode.cover]: 0,
      [BlockMode.view]: 0,
    },
  )
}

export const canInsertBlock = (copiedBlocks: IShortBlockData[], targetSection?: Section | null) => {
  const targetSectionType = targetSection?.type || SectionTypeEnum.landing
  const count = countBlocksByMode([...copiedBlocks, ...(targetSection?.blocks || [])])
  for (const mode of Object.keys(count) as (keyof typeof count)[]) {
    if (count[mode] > BLOCK_LIMITS[targetSectionType][mode]) {
      return false
    }
  }
  return true
}
